import styled from "styled-components";

import { DESKTOP_BREAKPOINT } from "../../components/AppShell/styles";
import { FormGroup } from "../../components/Form/styles";
import { StickyBarPage } from "../../components/SaveBar";

const MOBILE = `not all and (min-width: ${DESKTOP_BREAKPOINT})`;

export const Container = styled(StickyBarPage)``;

/* A titled block of the screen: small uppercase label + card (same as /settings) */
export const Section = styled.section`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 1.5rem 2rem 0;

  @media ${MOBILE} {
    padding: 20px 20px 0;
  }
`;

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 20px;
  background: var(--color-neutral-dark);
  border-radius: 1rem;

  /* The card's gap already spaces the fields */
  ${FormGroup} {
    margin-bottom: 0;
  }

  /* The note under the search preview, as close as a field's hint (the card's 1rem gap would detach it) */
  .preview-note {
    margin-top: -0.75rem;
    font-size: 0.75rem;
    line-height: 1rem;
    color: var(--color-neutral-150);
  }
`;

/* How the Keepo shows up in Google results */
export const SearchPreview = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding: 1rem;
  background: var(--color-neutral-white);
  border-radius: 12px;

  .url {
    overflow: hidden;
    font-family: Arial, sans-serif;
    font-size: 0.8125rem;
    color: #202124;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .title {
    overflow: hidden;
    font-family: Arial, sans-serif;
    font-size: 1.125rem;
    line-height: 1.5rem;
    color: #1a0dab;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .description {
    display: -webkit-box;
    overflow: hidden;
    font-family: Arial, sans-serif;
    font-size: 0.8125rem;
    line-height: 1.25rem;
    color: #4d5156;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;

    &.empty {
      font-style: italic;
      color: #9aa0a6;
    }
  }
`;

export const ToggleRow = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
  justify-content: space-between;

  .text {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    min-width: 0;
  }

  .description {
    font-size: 0.75rem;
    line-height: 1rem;
    color: var(--color-neutral-150);
  }

  /* The toggle's label is sized by its absolutely positioned track: give it the track's box */
  > label {
    flex-shrink: 0;
    width: 40px;
    height: 24px;
    padding: 0;
    margin: 0;

    input:not(:checked) ~ span {
      background-color: var(--color-neutral-base);
    }
  }
`;

/* An image setting: preview on the left, title/recommendation and actions on the right */
